import { Link } from 'react-router-dom';
import { getAllCategories } from '@/utils/course';

const quickLinks = [
  { label: '主页', to: '/' },
  { label: '课程分类', to: '/category' },
  { label: '搜索课程', to: '/search' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const categories = getAllCategories();

  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className="ri-graduation-cap-fill"></i>
              </span>
              <span className="font-heading font-extrabold text-xl text-background-50">
                秘密教学
              </span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/80 max-w-xs">
              专业的在线教育资源与课程培训平台，聚焦语言、IT、财经等多领域教学，帮助你高效学习、持续提升。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900/60 text-primary-100 text-lg hover:bg-primary-800 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-primary-100/75 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">
              课程分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category?cat=${cat.id}`}
                    className="text-sm text-primary-100/75 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-background-50 mb-4 text-sm tracking-wide">
              联系我们
            </h4>
            <ul className="space-y-3 text-sm text-primary-100/75">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-base mt-0.5">
                  <i className="ri-mail-line"></i>
                </span>
                <span>support@secretteaching.com</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-base mt-0.5">
                  <i className="ri-phone-line"></i>
                </span>
                <span>400-888-6688</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center text-base mt-0.5">
                  <i className="ri-map-pin-line"></i>
                </span>
                <span>北京市海淀区中关村教育科技园区 8 号楼</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-primary-100/60">
            © {year} 秘密教学 · 专业教育资源与课程培训平台
          </p>
          <p className="text-xs text-primary-100/60">本站为前端演示项目，数据仅供参考</p>
        </div>
      </div>
    </footer>
  );
}